// TODO: Update to `"knyt"`
export const DEFAULT_NAME_PREFIX = "knyt";
/**
 * Default base font size in pixels.
 *
 * This value is used to convert between pixels and rems.
 *
 * This value should be referenced from the `GlobalTheme`:
 * `GlobalTheme.defaultConfig.baseFontSizePx`
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/CSS/font-size | MDN font-size}
 *
 * @internal scope: package
 */
export const DEFAULT_BASE_FONT_SIZE_PX = 16;
